import React from "react";

import Tooltip from "@common/components/Tooltip/Tooltip";
import { Attachment } from "@common/models";
import * as Styled from "@public/pages/shared/components/Attachments/AttachmentButtons/AttachmentButtons.styles";
import * as Icon from "@public/pages/shared/components/Attachments/icons";

interface AttachmentButtonsProps {
  attachment: Attachment;
  onRemoveClick?: (attachment: Attachment) => void;
}

export const AttachmentButtons = ({ attachment, onRemoveClick }: AttachmentButtonsProps) => {
  return (
    <Styled.AttachmentButtonsContainer>
      {onRemoveClick ? (
        <Tooltip
          style={{ width: "auto" }}
          text="Remove"
          position="bottom"
        >
          <Styled.AttachmentButton onClick={() => onRemoveClick?.(attachment)}>
            <Icon.TrashIcon />
          </Styled.AttachmentButton>
        </Tooltip>
      ) : null}
      <Tooltip
        style={{ width: "auto" }}
        text="Download"
        position="bottom"
      >
        <Styled.AttachmentButton
          href={attachment?.url}
          download
          target="_blank"
        >
          <Icon.DownloadIcon />
        </Styled.AttachmentButton>
      </Tooltip>
    </Styled.AttachmentButtonsContainer>
  );
};
